import * as React from "react";
import { faShieldCheck } from "@fortawesome/pro-solid-svg-icons/faShieldCheck";
import { faShield } from "@fortawesome/pro-solid-svg-icons/faShield";
import MuiIconFa, { MuiIconFaProps } from "components/MuiExtras/MuiIconFa";


interface IProps {
    active: boolean;
}

type Props = IProps & Omit<MuiIconFaProps, "icon">;

const IconUserSpecialist: React.FC<Props> = (props) => {
    const { active, title, ...rest } = props;
    return <MuiIconFa {...rest} title={title || "Especialista"} icon={active ? faShieldCheck : faShield} />
}

export default IconUserSpecialist

